'use strict';

function Project() {
  var $duration = $('.field--name-field-duration-start .field-duration');
  var $durationObj = $duration.data('duration');
  if ($duration.length == 0) {
    return false;
  }
  $duration.append('<div class="duration"><div class="duration__time"></div><div class="duration__bar"><span></span></div></div>');
  var totalYears = $durationObj.project.end.year - $durationObj.project.start.year;
  var totalYearsInMonths = totalYears * 12;
  var totalDurationInMonths = totalYearsInMonths - $durationObj.project.current.year - (12 - $durationObj.project.end.year);
  var percentageComplete = (totalDurationInMonths / totalYearsInMonths * 100).toFixed(6);
  var timelineHTML = '<ul>';
  timelineHTML += '<li>' + $durationObj.project.start.year + '</li>';
  timelineHTML += '<li>' + $durationObj.project.end.year + '</li>';
  timelineHTML += '</ul>';
  $duration.find('.duration__time').append(timelineHTML);
  $duration.find('.duration__bar span').width(percentageComplete + '%'); // ScrollMonitor Stuff

  $('.page-node-type-project .node__content .field').each(function (i, v) {
    var $this = $(v);
    var cardWatcher = scrollMonitor.create($this);
    cardWatcher.enterViewport(function () {
      $this.addClass('-show');
    });
  });
};
export default Project;
